module.exports = __webpack_public_path__ + "media/media/distributors/scott-jones-2-4c36f011303fbb38a93eb4f370b38143.jpg";